/** @jsxImportSource @emotion/react */
import '@app/routes/App/App.css'
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  css,
  Typography,
} from '@mui/material'
import { appContainer, appContentContainer } from '@app/routes/App/App.styles'
import { showFeedbackModalAtom } from '@app/state/modalAtom'
import { theme } from '@app/styles/theme'
import { useAtom } from 'jotai'
import { secondaryTextPrimary } from '../AdaptationPage/AdaptationPage.styles'

export const ErrorPage = () => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useAtom(showFeedbackModalAtom)

  return (
    <>
      <Box css={appContainer}>
        <Box css={appContentContainer()}>
          <Box
            css={css`
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background-color: #0b294840;
            `}
          >
            <Card sx={{ width: '60vw', maxWidth: '800px', maxHeight: '100%', overflow: 'auto' }}>
              <CardMedia
                sx={{ height: '50vh', backgroundSize: 'contain' }}
                image="/images/illustrations/404NotFound.svg"
                title="Example of the live screen"
              />
              <CardContent>
                <Typography variant="h2" component="div" css={secondaryTextPrimary({ theme })}>
                  An unexpected error has occurred
                </Typography>
                <Typography variant="body1">
                  Apologies for the inconvenience. Please report this issue and try again later.
                </Typography>
              </CardContent>
              <CardActions sx={{ padding: theme.spacing(4) }}>
                <Button
                  size="medium"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  sx={{
                    marginBottom: theme.spacing(2),
                  }}
                  onClick={() => setIsFeedbackModalOpen(!isFeedbackModalOpen)}
                >
                  Submit Feedback
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Box>
      </Box>
    </>
  )
}
